import { Link } from "react-router-dom";
import { ROUTE_ABOUT } from "../../../const/routes.ts";
import PopUp, { closeModal } from "../PopUp.tsx";
import { useCookie } from "../../../hooks/useCookie.ts";
import { IconCookie } from "@tabler/icons-react";
import { useEffect } from "react";

const closeNotice = () => closeModal("cookie-notice");
const CookieNotice = () => {
  const { ackCookie } = useCookie();
  useEffect(() => {
    ackCookie();
  }, []);
  return (
    <PopUp
      id="cookie-notice"
      position="modal-bottom"
      title={
        <>
          <IconCookie />
          Es werden keine Tracking oder Werbe-Cookies benutzt
        </>
      }
    >
      <div className="flex flex-col gap-5">
        <p>
          Lies in der{" "}
          <Link className="link" to={ROUTE_ABOUT} onClick={closeNotice}>
            Datenschutzerklärung
          </Link>{" "}
          nach, wie Surfanzeigen.de mit deinen! Daten umgeht. Die Seite
          speichert lokal die ausgewählte Darstellungsart (Dark-/Light-Mode,
          Listen-/Kartenlayout, Anzeigen pro Seite). Viel Spaß beim Surfen!
        </p>
        <div className="flex justify-around" onClick={closeNotice}>
          <Link
            className="btn rounded-full underline btn-neutral min-w-1/3"
            to={ROUTE_ABOUT}
          >
            Mehr
          </Link>
          <button className="btn rounded-full btn-success min-w-1/3">
            Alles klar
          </button>
        </div>
      </div>
    </PopUp>
  );
};
export default CookieNotice;
